import { Component, input } from '@angular/core';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { Contract } from 'app/shared/models/contract.model';

@Component({
  selector: 'ez-contract-info',
  imports: [CurrencyPipe, DatePipe],
  templateUrl: './contract-info.component.html',
  styleUrls: ['./contract-info.component.scss'],
})
export class ContractInfoComponent {
  readonly contract = input.required<Contract>();
}
